import React, { useState,useEffect } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { isNull,isObjEmpty,escapeHtml, unescapeHtml,ChangeSimpleDateString } from "../../components/common/Common";

import "../../css/style.css";

//공지사항 편집/등록/보기
const InquiryDetail = () => {
  let { board_idx } = useParams();
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varInquiryInfo,setInquiryInfo] = useState({});

  //답변유무
  const [varSendPush,setSendPush] = useState(false);

  const GetInquiryInformation = async() => {
    const sendData = {board_idx:board_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_inquiry_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const childrens = datas.inquirys;
        setInquiryInfo(childrens[0]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    //작업모드 
    GetInquiryInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //답변쓰기
  const onChangeAnswerHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "board_status") {
      if(Number(value)===1) setInquiryInfo({...varInquiryInfo,board_status:1,board_answer:null});
      else setInquiryInfo({...varInquiryInfo,board_status:2});
    } else {
      setInquiryInfo({...varInquiryInfo,[name]:escapeHtml(value)});
    }
    //답변이 변경되면
    if(name === "board_answer") setSendPush(true);
  }

  //등록-------------------------------------------------------------------------------------
  const onUpdateAnswerHandler = async(e) => {
    if(isNull(varInquiryInfo.board_answer)) {
      alert('1:1문의의 답변을 먼저 입력하세요.'); return false;
    }

    let prompt = "현재 지정된 1:1문의의 답변을 저장합니까?";
    if(Number(board_idx) === 0)  prompt = "입력하신 1:1문의을 등록합니까?";
    if(!window.confirm(prompt)) return false;

    const sendData = {branch_idx:branch_idx,board_idx:board_idx,dataInfo:varInquiryInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_inquirys`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(varSendPush) SendPushMessage();
        else navigate('/Branch/InquirySet');
      } else {
        alert(datas.message);
      }
    });
  }

  //푸시보내기
  const SendPushMessage = async () => {
    const pushTitle = "[마마몽떼] 1:1문의에 대한 답변이 등록되었습니다.";
    const pushMessage = varInquiryInfo.board_title;
    const pushUrl = `${process.env.REACT_APP_WEB_URL}/Parents/QuestionView/${board_idx}`;
    const sendData = {mode:1,oppIdx:varInquiryInfo.quest_idx,pushTitle:pushTitle,pushMessage:pushMessage,pushUrl:pushUrl};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_push_single_message`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        navigate('/Branch/InquirySet');
      }
    });
  }

  return isObjEmpty(varInquiryInfo)?null:(
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'1:1 문의 답변'} varBackString={'/Branch/InquirySet'}/>
      <div className="vh-content-body">
        <div className="center-wrap">
					<div className="oper-inq-wrap">
            <div className="inq-con">
              {/* 질문 */}
              <div className="inq-quest-box">
                <ul>
                  <li>
                    <p>문의 일자</p>
                    <div>{ChangeSimpleDateString(varInquiryInfo.board_rdate)}</div>
                  </li>
                  <li>
                    <p>학부모(원아)</p>
                    <div>{`${varInquiryInfo.mem_name} (${varInquiryInfo.ch_name})`} </div>
                  </li>
                  <li>
                    <p>문의 제목</p>
                    <div>{unescapeHtml(varInquiryInfo.board_title)}</div>
                  </li>
                  <li>
                    <p>문의 내용</p>
                    <div>{unescapeHtml(varInquiryInfo.board_question)}</div>
                  </li>
                </ul>
              </div>
              {/* 답변 */}
              <div className="inq-answer-box">
                <div className="form-group mb15">
                  <label className="form-label">답변</label>
                  <div className="field-group">
                    <textarea className="" name="board_answer" value={unescapeHtml(varInquiryInfo.board_answer)} onChange={e=>onChangeAnswerHandler(e)}/>
                  </div>
                </div>

                {/* <div className="form-group mb15">
                  <label className="form-label">처리여부</label>
                  <div className="field-group">
                    <select name="board_status" value={varInquiryInfo.board_status} onChange={e=>onChangeAnswerHandler(e)}>
                      <option value={2}>완료</option>
                      <option value={1}>대기</option>
                    </select>
                  </div>
                </div> */}
              </div>
              <div className="form-contoller bt-btn st02">
                <Link to={'/Branch/InquirySet'} className="form-contoller-btn btn-no" style={{width:"48%"}}>이전</Link>
                <button className="form-contoller-btn btn-yes" onClick={e=>onUpdateAnswerHandler(e)}>답변하기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default InquiryDetail;